  import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
  import HeaderBreadCrumbs from "../../Component/BasicComponents/HeaderBreadCrumbs";
  import { Href } from "../../utils/Constant";
  import { useState } from "react";
  import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
  import { FaEdit } from "react-icons/fa";
  import { useLocation } from "react-router-dom";
  import { Btn } from "../../AbstractElements";
  import ReusableDropdown from "../../Component/BasicComponents/Dropdowns/Dropdown";
  import MultiSelectDropdown from "../../Component/BasicComponents/Dropdowns/MultiSelectDropdown";
  import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
  import ProductListByBrandModalContent from "./ModalContent/ProductListByBrandModalContent";
  import { useGetBrandCompetitionList } from "./hooks/useProductCatalogue";

  const ProductListbyBrand = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedBrand, setSelectedBrand] = useState<any>(null);
      const [filtersState, setFiltersState] = useState<any>({
    orgUnits: null,
    gradeMaster: null,
    designation: null,
    status: null,
    limit: 10,
    page: 1,
    search: null,
    Position:null,
  });
    const location = useLocation();
    console.log('location of product list',location.state.brand)
      const [mode, setmode] = useState<"add" | "edit">("add");
    
    const selectedBrandName = location.state?.brand || "Products";
  

    const {data:getBrandCompetitionList,isLoading}=useGetBrandCompetitionList({
      id:selectedBrandName.id,
      enabled:true,
      params:{
        length:filtersState.limit,
        start:filtersState.page,
        search:filtersState.search
      }
    })



    console.log('getCompetitionList',getBrandCompetitionList?.data)

    const [selectedNames, setSelectedNames] = useState<
      { id: number; name: string }[]
    >([]);

    const toggleModal = () => {
      setIsModalOpen(!isModalOpen);
      if (!isModalOpen) setSelectedBrand(null); 
      setmode('add')// Reset selected brand when closing
    };

    const handleEditClick = (brand: any) => {
      setSelectedBrand(brand); // Set existing brand data
      setIsModalOpen(true); // Open modal
          setmode("edit");
    };

    const handleClose = () => {
      setIsModalOpen(false);
      // setSelectedBrand(null);
    };



 

    const productDataColumns = [
      {
        name: "Competitor Name",
        selector: (row: { CompetitorName: number | string }) =>
        row.CompetitorName,
        sortable: true,
        minWidth:'200px'
      },
      {
        name: "Brand",
        selector: (row: { BrandName: string }) => row.BrandName,
        sortable: true,
      },
      {
        name: "Org Unit",
        selector: (row: { UnitName: string }) => row.UnitName,
        sortable: true,
      },
      {
        name: "Drate",
        selector: (row: { Drate: string }) => row.Drate,
        sortable: true,
      },
      {
        name: "Created on",
        selector: (row: { CreatedAt: string }) => row.CreatedAt.split('.')[0],
        sortable: true,
        wrap:true,
        width:'130px'
      },
      {
        name: "Modified on",
        selector: (row: { UpdatedAt: string }) => row.UpdatedAt,
        sortable: true,
        width:'130px'

      },
      {
        name: "Action",
        cell: (row: any) => (
          <button
            onClick={() => handleEditClick(row)}
            className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
            style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
          >
            <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
          </button>
        ),
      },
    ];

      const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };


    return (
      <div className="p-2">
        <PageHeader
          title={`Brand Competitors For ${selectedBrandName.brand} | ${selectedBrandName.id}`}
          buttons={[
            {
              label: "+ Add Competitors",
              onClick: toggleModal,
              color: "#2e8dd3",
            },
            {
              label: "Excel",
              onClick: () => alert("Action 2 clicked"),
              color: "#43B9B2",
            },
            {
              label: "CSV",
              onClick: () => alert("Action 3 clicked"),
              color: "#43B9B2",
            },
          ]}
        />

        <BasicDataTable
        paginationTotalRows={getBrandCompetitionList?.data?.recordsTotal}
        showSpinner={isLoading}
          Title="Competitors list"
          data={getBrandCompetitionList?.data?.data}
          columns={productDataColumns}
              onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        />
        <RouteModal
          isOpen={isModalOpen}
          toggle={toggleModal}
          title={
            selectedBrand ? "Edit Brand Competitor" : "Add Brand competitor"
          }
          size="md"
          content={
            <ProductListByBrandModalContent
            selectedBrand={selectedBrand||{}}
            selectedNames={selectedNames}
            setSelectedNames={setSelectedNames}
            mode={mode}
            productID={location.state.brand.id}
            ProductData={location.state.brand}          
            handleClose={handleClose}
         
          />
          }
        />
      </div>
    );
  };

  export default ProductListbyBrand;
